// extracted by mini-css-extract-plugin
export default {"UserTweetPageContainer":"UserTweetPage_UserTweetPageContainer__tUMz8"};